import Wargamer from './Wargamer';
import WorldOfTanks from './clients/WorldOfTanks';
import WorldOfTanksBlitz from './clients/WorldOfTanksBlitz';
import WorldOfTanksConsole from './clients/WorldOfTanksConsole';
import WorldOfWarships from './clients/WorldOfWarships';
import WorldOfWarplanes from './clients/WorldOfWarplanes';
import Wargaming from './clients/Wargaming';

export {
  WorldOfTanks,
  WorldOfTanksBlitz,
  WorldOfTanksConsole,
  WorldOfWarships,
  WorldOfWarplanes,
  Wargaming,
};

export default Wargamer;



// WEBPACK FOOTER //
// ./src/index.js